import moment from 'moment';
import { createAsyncAction } from "./utils";
export var getCreditFactorHistory = createAsyncAction('getCreditFactorHistory', function (factor, start, end, interval, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.TUCreditReport.getCreditFactorHistory(factor, start, end, interval, serverRequest);
    }
  };
});
export var getCreditProfileRecentChanges = createAsyncAction('getCreditProfileRecentChanges', function (serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.TUCreditReport.getCreditProfileRecentChanges(serverRequest);
    }
  };
});
export var getCreditProfileAlerts = createAsyncAction('getCreditProfileAlerts', function (serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      var today = moment().toDate();
      var threeMonthsAgo = moment().subtract(3, 'months').toDate();
      return opts.IdentitySDK.TUCreditReport.getCreditProfileAlerts(threeMonthsAgo, today, serverRequest);
    }
  };
});